export default __webpack_public_path__ + "static/media/906.1598a328.png";